// MUI Imports
import type { Theme } from '@mui/material/styles';

const paper: Theme['components'] = {
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundImage: 'none',
        '& .dropDown-menu': {
          '& .MuiButtonBase-root:not(:first-of-type)': {
            marginInlineStart: 0,
          },
        },
      },
    },
  },
};

export default paper;
